import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createBlock as _createBlock, resolveComponent as _resolveComponent, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "product-tile__top" }
const _hoisted_2 = { class: "row g-0 product-tile__tags" }
const _hoisted_3 = { class: "col col-auto" }
const _hoisted_4 = { class: "container container-fluid g-0" }
const _hoisted_5 = { class: "row g-2" }
const _hoisted_6 = {
  key: 0,
  class: "col col-auto align-self-center"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 1,
  class: "col col-auto align-self-center"
}
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = {
  key: 0,
  class: "col col-auto"
}
const _hoisted_11 = {
  key: 2,
  class: "col col-auto"
}
const _hoisted_12 = {
  key: 0,
  class: "col col-auto"
}
const _hoisted_13 = { class: "row g-0 product-tile__bottom" }
const _hoisted_14 = { class: "col col-12 product-tile__bottom__info" }
const _hoisted_15 = { class: "product-tile__art-no" }
const _hoisted_16 = { class: "product-tile__header" }
const _hoisted_17 = { class: "product-tile__variants" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { key: 2 }
const _hoisted_21 = { key: 3 }
const _hoisted_22 = { class: "col col-12" }
const _hoisted_23 = { class: "product-tile__price-container" }
const _hoisted_24 = { class: "col col-auto" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = {
  key: 1,
  class: "product-tile__price__from"
}
const _hoisted_27 = { key: 0 }
const _hoisted_28 = {
  key: 1,
  class: "product-tile__price__from"
}
const _hoisted_29 = {
  key: 2,
  class: "product-tile__vat"
}
const _hoisted_30 = {
  key: 3,
  class: "product-tile__vat"
}
const _hoisted_31 = { key: 1 }
const _hoisted_32 = { class: "col product-tile__buttons" }
const _hoisted_33 = {
  key: 0,
  class: "col col-auto d-none d-md-block"
}
const _hoisted_34 = ["href"]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", null, "DWG", -1)
const _hoisted_36 = {
  key: 1,
  class: "col col-auto d-none d-md-block"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", null, "DWG", -1)
const _hoisted_38 = { class: "col col-auto" }
const _hoisted_39 = { class: "umbraco-form-modal__header" }
const _hoisted_40 = { class: "umbraco-form-modal" }
const _hoisted_41 = { class: "umbraco-form-modal__header" }
const _hoisted_42 = { class: "umbraco-form-modal" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("p", null, null, -1)

import ImageDefaultProductTile from "@/components/images/ImageDefaultProductTile.vue";
import IconCart from "@/components/icons/IconCart.vue";
import IconChevronRight from "@/components/icons/IconChevronRight.vue";
import IconDownload from "@/components/icons/IconDownload.vue";
import IconFavorite from "@/components/icons/IconFavorite.vue";
import TressButton from "@/components/TressButton.vue";
import TressIconButton from "@/components/TressIconButton.vue";
import TressLink from "@/components/TressLink.vue";
import TressProductTileTag from "@/components/TressProductTileTag.vue";
import TressResponsivePicture from "@/components/TressResponsivePicture.vue";
import { Site } from "@/enums/Site";
import { PriceType } from "@/enums/PriceType";
import { StockStatus } from "@/enums/StockStatus";
import dictionary from "@/i18n/dictionary.json";
import { ProductTile, VariantSelector } from "@/models/ProductList";
import { useCustomer } from "@/store/useCustomer";
import { computed, inject, nextTick, PropType, ref } from "vue";
import { useAsyncSpinner } from "@/services/Spinner";
import TressLoginModal from "@/components/TressLoginModal.vue";
import { useCart } from "@/store/useCart";
import { FavoritesApi } from "@/services/Api";
import { IAntiForgeryToken } from "@/models/umbraco-forms/IAntiForgeryToken";
import { IUmbracoFormUserPreValues } from "@/models/umbraco-forms/IUmbracoFormUserPreValues";
import { useUmbracoForm } from "@/store/useUmbracoForm";
import { Emitter } from "mitt";
import { ILink } from "@/models/ILink";

const productLinkClassName = "product-tile__link";

export default /*#__PURE__*/_defineComponent({
  __name: 'TressProductTile',
  props: {
  content: {
    type: Object as PropType<ProductTile>,
    required: true,
  },
  showAsB2b: {
    type: Boolean,
    required: true,
  },
  small: {
    type: Boolean,
    required: true,
  },
  antiForgeryToken: {
    type: Object as PropType<IAntiForgeryToken>,
    required: false,
  },
  preValues: {
    type: Object as PropType<IUmbracoFormUserPreValues>,
    required: false,
  },
  index: {
    type: Number,
    required: true,
  },
  blueSiteLogotype: {
    type: String,
    required: false,
  },
  fastDeliveryLogotype: {
    type: String,
    required: false,
  },
  fastDeliveryAltText: {
    type: String,
    required: false,
  },
},
  setup(__props) {

const props = __props;

const cartStore = useCart();
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const emitter = inject<Emitter<any>>("eventbus")!;
const site = inject<string>("tressSite");
const customer = useCustomer();
const tileElement = ref<HTMLElement>();


const isFavorited = ref<boolean>(props.content.isFavorited);
const preValues = ref<IUmbracoFormUserPreValues | undefined>(props.preValues);
if (preValues.value) {
  preValues.value = { ...preValues.value, sku: props.content?.sku };
}

const hasStock = computed(() => {
  return props.content.stockStatus != StockStatus.OutOfStock;
});
const price = computed(() => {
  if (props.showAsB2b) {
    return props.content.price;
  }
  return props.content.priceIncVat;
});
const oldPrice = computed(() => {
  if (props.showAsB2b) {
    return props.content.originalPrice;
  }
  return props.content.originalPriceIncVat;
});
const onFavoriteClick = async () => {
  if (window.isLoggedIn) {
    isFavorited.value = !isFavorited.value;
    FavoritesApi.post(props.content?.sku, isFavorited.value).then(() => {
      nextTick(() => {
        if (isFavorited.value) {
          emitter.emit("favoriteAdded");
        } else {
          emitter.emit("favoriteRemoved");
        }
      });
    });
  } else {
    openLoginForm();
  }
};
const onCartClick = async (partNo: string, quantity: number) => {
  await useAsyncSpinner(async () => {
    await cartStore.addToCart(partNo, quantity, true);
    if (typeof window !== "undefined" && window.BiTracking) {
      const row = cartStore.rows.find((r) => r.item.partNo === partNo);
      window.BiTracking.addToBasket(partNo, row?.quantity, "", cartStore.id, "");
    }
  });
};
const isBuyable = computed(() => {
  if (site == Site.Blue) {
    return true;
  }
  return true;
});
const link = computed((): ILink | null => {
  if (site == Site.Blue || isBuyable.value) {
    return { url: props.content.url };
  }
  return null;
});

const isRequestForFileOpen = ref<boolean>(false);
const openRequestForFile = () => {
  isRequestForFileOpen.value = true;
};
const closeRequestForFile = () => {
  isRequestForFileOpen.value = false;
};

const isRequestForPriceOpen = ref<boolean>(false);
const openRequestForPrice = () => {
  isRequestForPriceOpen.value = true;
};
const closeRequestForPrice = () => {
  isRequestForPriceOpen.value = false;
};
const umbracoForms = useUmbracoForm();
const isLoginFormOpen = ref<boolean>(false);
const closeLoginForm = () => {
  isLoginFormOpen.value = false;
};
const openLoginForm = () => {
  isLoginFormOpen.value = true;
};
const loginUrl = ref<string>(window.loginUrl);
const loginUrlWithParameters = computed(() => {
  return `${loginUrl.value}?returnurl=${window.location.pathname}`;
});

return (_ctx: any,_cache: any) => {
  const _component_icon_mail = _resolveComponent("icon-mail")!
  const _component_icon_checkmark = _resolveComponent("icon-checkmark")!
  const _component_tress_buy_button_icon = _resolveComponent("tress-buy-button-icon")!
  const _component_umbraco_form_field = _resolveComponent("umbraco-form-field")!
  const _component_umbraco_form_fieldset_column = _resolveComponent("umbraco-form-fieldset-column")!
  const _component_umbraco_form_fieldset = _resolveComponent("umbraco-form-fieldset")!
  const _component_umbraco_form_page = _resolveComponent("umbraco-form-page")!
  const _component_umbraco_form = _resolveComponent("umbraco-form")!
  const _component_tress_modal = _resolveComponent("tress-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass([{
      'product-tile--zoom': _unref(site) == _unref(Site).Green,
      'product-tile--not-in-stock': !hasStock.value && !__props.showAsB2b,
      'product-tile--green': _unref(site) == _unref(Site).Green,
    }, "row g-0 product-tile"])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (__props.content.isExternal)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(TressLink, {
                        link: link.value,
                        class: _normalizeClass([productLinkClassName, "product-tile__external-logo product-tile__external-logo--dynamic"]),
                        sku: __props.content.sku
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", { src: __props.blueSiteLogotype }, null, 8, _hoisted_7)
                        ]),
                        _: 1
                      }, 8, ["link", "sku"])
                    ]))
                  : _createCommentVNode("", true),
                (__props.content.fastDelivery)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createVNode(TressLink, {
                        link: link.value,
                        class: _normalizeClass([productLinkClassName, "product-tile__fast-delivery-logo"]),
                        sku: __props.content.sku
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            src: __props.fastDeliveryLogotype,
                            alt: __props.fastDeliveryAltText
                          }, null, 8, _hoisted_9)
                        ]),
                        _: 1
                      }, 8, ["link", "sku"])
                    ]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      (__props.content.new)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createVNode(TressLink, {
                              link: link.value,
                              class: _normalizeClass(productLinkClassName),
                              sku: __props.content.sku
                            }, {
                              default: _withCtx(() => [
                                _createVNode(TressProductTileTag, {
                                  class: _normalizeClass(["product-tile-tag--alternative product-tile-tag--new d-none d-lg-block", { 'd-lg-none': __props.small }])
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t(_unref(dictionary).common.new)), 1)
                                  ]),
                                  _: 1
                                }, 8, ["class"])
                              ]),
                              _: 1
                            }, 8, ["link", "sku"])
                          ]))
                        : _createCommentVNode("", true),
                      (__props.content.priceType == _unref(PriceType).Campaign && __props.content.discountPercent)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: _normalizeClass(["col col-auto", {
                    'd-none d-lg-block': __props.small,
                  }])
                          }, [
                            _createVNode(TressLink, {
                              link: link.value,
                              class: _normalizeClass(productLinkClassName),
                              sku: __props.content.sku
                            }, {
                              default: _withCtx(() => [
                                _createVNode(TressProductTileTag, { class: "product-tile-tag--alternative" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(__props.content.discountPercent) + " % ", 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["link", "sku"])
                          ], 2))
                        : _createCommentVNode("", true),
                      (__props.content.priceType == _unref(PriceType).Agreement)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createVNode(TressLink, {
                              link: link.value,
                              class: _normalizeClass(productLinkClassName),
                              sku: __props.content.sku
                            }, {
                              default: _withCtx(() => [
                                _createVNode(TressProductTileTag, { class: "product-tile-tag--agreement-price" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t(_unref(dictionary).common.agreementPrice)), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["link", "sku"])
                          ]))
                        : _createCommentVNode("", true),
                      (__props.content.hasQuantityBreaks)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 3,
                            class: _normalizeClass(["col col-auto", {
                    'd-none d-lg-block':
                      (__props.content.priceType == _unref(PriceType).Campaign && __props.content.discountPercent) ||
                      __props.content.priceType == _unref(PriceType).Agreement,
                    'd-lg-none':
                      __props.small &&
                      ((__props.content.priceType == _unref(PriceType).Campaign && __props.content.discountPercent) ||
                        __props.content.priceType == _unref(PriceType).Agreement),
                  }])
                          }, [
                            _createVNode(TressLink, {
                              link: link.value,
                              class: _normalizeClass(productLinkClassName),
                              sku: __props.content.sku
                            }, {
                              default: _withCtx(() => [
                                _createVNode(TressProductTileTag, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t(_unref(dictionary).common.massDiscount)), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["link", "sku"])
                          ], 2))
                        : _createCommentVNode("", true)
                    ], 64))
              ])
            ])
          ]),
          (!__props.content.isExternal)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(TressIconButton, {
                  class: _normalizeClass([{ 'product-tile__favorite-button--active': isFavorited.value }, "product-tile__favorite-button"]),
                  onClick: onFavoriteClick
                }, {
                  default: _withCtx(() => [
                    _createVNode(IconFavorite, { "is-filled": isFavorited.value }, null, 8, ["is-filled"])
                  ]),
                  _: 1
                }, 8, ["class"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(TressLink, {
          link: link.value,
          class: _normalizeClass(productLinkClassName),
          sku: __props.content.sku
        }, {
          default: _withCtx(() => [
            (__props.content.imageUrl?.url)
              ? (_openBlock(), _createBlock(TressResponsivePicture, {
                  key: 0,
                  pictures: { desktop: { url: __props.content.imageUrl.url }, hover: { url: __props.content.hoverImageUrl?.url } },
                  class: _normalizeClass(["product-tile__image", {
            'product-tile__image--blue': _unref(site) == _unref(Site).Blue,
          }])
                }, null, 8, ["pictures", "class"]))
              : (_openBlock(), _createBlock(ImageDefaultProductTile, { key: 1 }))
          ]),
          _: 1
        }, 8, ["link", "sku"])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createVNode(TressLink, {
            link: link.value,
            class: _normalizeClass(productLinkClassName),
            sku: __props.content.sku
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_15, _toDisplayString(__props.content.sku), 1)
            ]),
            _: 1
          }, 8, ["link", "sku"]),
          _createVNode(TressLink, {
            link: link.value,
            class: _normalizeClass(productLinkClassName),
            sku: __props.content.sku
          }, {
            default: _withCtx(() => [
              _createElementVNode("h2", _hoisted_16, _toDisplayString(__props.content.name), 1)
            ]),
            _: 1
          }, 8, ["link", "sku"]),
          (__props.content.hasVariants)
            ? (_openBlock(), _createBlock(TressLink, {
                key: 0,
                link: link.value,
                class: _normalizeClass(productLinkClassName),
                sku: __props.content.sku
              }, {
                default: _withCtx(() => [
                  _createElementVNode("p", _hoisted_17, [
                    _createTextVNode(" + " + _toDisplayString(__props.content.numberOfVariants) + " ", 1),
                    (__props.content.selector == _unref(VariantSelector).Size)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.$t(_unref(dictionary).producttile.sizes)), 1))
                      : (__props.content.selector == _unref(VariantSelector).Color)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.$t(_unref(dictionary).producttile.colors)), 1))
                        : (__props.content.selector == _unref(VariantSelector).Hardness)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.$t(_unref(dictionary).producttile.hardnesses)), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.$t(_unref(dictionary).producttile.variants)), 1))
                  ])
                ]),
                _: 1
              }, 8, ["link", "sku"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              (!__props.content.callForPrice)
                ? (_openBlock(), _createBlock(TressLink, {
                    key: 0,
                    link: link.value,
                    class: _normalizeClass(productLinkClassName),
                    sku: __props.content.sku
                  }, {
                    default: _withCtx(() => [
                      (_unref(customer).pricesAsB2b)
                        ? (_openBlock(), _createElementBlock("p", {
                            key: 0,
                            class: _normalizeClass(["product-tile__price", {
                  'product-tile__price--campaign': __props.content.originalPrice && __props.content.discountPercent > 0,
                  'product-tile__price--blue': _unref(site) == _unref(Site).Blue,
                }])
                          }, [
                            (__props.content.originalPrice && __props.content.discountPercent > 0)
                              ? (_openBlock(), _createElementBlock("s", _hoisted_25, _toDisplayString(oldPrice.value), 1))
                              : _createCommentVNode("", true),
                            (__props.content.hasVariants)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.$t(_unref(dictionary).common.from)) + " ", 1))
                              : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(price.value), 1)
                          ], 2))
                        : (_openBlock(), _createElementBlock("p", {
                            key: 1,
                            class: _normalizeClass(["product-tile__price", {
                  'product-tile__price--campaign': __props.content.originalPriceIncVat && __props.content.discountPercent > 0,
                  'product-tile__price--blue': _unref(site) == _unref(Site).Blue,
                }])
                          }, [
                            (__props.content.originalPriceIncVat && __props.content.discountPercent > 0)
                              ? (_openBlock(), _createElementBlock("s", _hoisted_27, _toDisplayString(oldPrice.value), 1))
                              : _createCommentVNode("", true),
                            (__props.content.hasVariants)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.$t(_unref(dictionary).common.from)) + " ", 1))
                              : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(price.value), 1)
                          ], 2)),
                      (__props.showAsB2b)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString(_ctx.$t(_unref(dictionary).common.excludeVat)), 1))
                        : (_openBlock(), _createElementBlock("p", _hoisted_30, _toDisplayString(_ctx.$t(_unref(dictionary).common.includeVat)), 1))
                    ]),
                    _: 1
                  }, 8, ["link", "sku"]))
                : _createCommentVNode("", true),
              (__props.content.callForPrice)
                ? (_openBlock(), _createElementBlock("p", _hoisted_31, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.$t(_unref(dictionary).product.callforprice)), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_32, [
              (_unref(site) == _unref(Site).Blue && __props.content.hasDwgs)
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    _createElementVNode("a", {
                      href: __props.content.dwgDownloadUrl,
                      target: "_blank"
                    }, [
                      _createVNode(TressButton, { class: "product-tile__download-button" }, {
                        default: _withCtx(() => [
                          _hoisted_35,
                          _createVNode(IconDownload)
                        ]),
                        _: 1
                      })
                    ], 8, _hoisted_34)
                  ]))
                : (_unref(site) == _unref(Site).Blue && !__props.content.hasDwgs)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                      _createVNode(TressButton, { class: "product-tile__download-button" }, {
                        default: _withCtx(() => [
                          _hoisted_37,
                          _createVNode(_component_icon_mail)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
              _createElementVNode("div", {
                ref_key: "tileElement",
                ref: tileElement
              }, [
                _createElementVNode("div", _hoisted_38, [
                  (__props.content.isExternal)
                    ? (_openBlock(), _createBlock(TressLink, {
                        key: 0,
                        link: link.value,
                        class: _normalizeClass(productLinkClassName),
                        sku: __props.content.sku
                      }, {
                        default: _withCtx(() => [
                          _createVNode(TressIconButton, {
                            class: "button--button-icon product-tile__buy-button product-tile__button-cart product-tile__button-cart--arrow product-tile__button-cart--external",
                            disabled: !hasStock.value && !__props.showAsB2b
                          }, {
                            default: _withCtx(() => [
                              _createVNode(IconChevronRight, { class: "product-tile__buy-button__icon" })
                            ]),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        _: 1
                      }, 8, ["link", "sku"]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (__props.content.callForPrice)
                          ? (_openBlock(), _createBlock(TressIconButton, {
                              key: 0,
                              class: "button--button-icon product-tile__buy-button product-tile__button-cart",
                              onClick: openRequestForPrice
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_icon_mail, { class: "product-tile__buy-button__icon" })
                              ]),
                              _: 1
                            }))
                          : (__props.content.hasVariants)
                            ? (_openBlock(), _createBlock(TressLink, {
                                key: 1,
                                link: link.value,
                                class: _normalizeClass(productLinkClassName),
                                sku: __props.content.sku
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(TressIconButton, {
                                    class: "button--button-icon product-tile__buy-button product-tile__button-cart product-tile__button-cart--arrow",
                                    disabled: !hasStock.value && !__props.showAsB2b
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(IconChevronRight, { class: "product-tile__buy-button__icon" })
                                    ]),
                                    _: 1
                                  }, 8, ["disabled"])
                                ]),
                                _: 1
                              }, 8, ["link", "sku"]))
                            : (_openBlock(), _createBlock(_component_tress_buy_button_icon, {
                                key: 2,
                                "data-sku": __props.content.sku,
                                class: "button--button-icon product-tile__buy-button product-tile__button-cart",
                                disabled: !hasStock.value && !__props.showAsB2b,
                                onClick: _cache[0] || (_cache[0] = ($event: any) => (onCartClick(__props.content.sku, 1)))
                              }, {
                                on: _withCtx(() => [
                                  _createVNode(_component_icon_checkmark, { class: "product-tile__buy-button__icon--checkmark" })
                                ]),
                                off: _withCtx(() => [
                                  _createVNode(IconCart, { class: "product-tile__buy-button__icon" })
                                ]),
                                _: 1
                              }, 8, ["data-sku", "disabled"]))
                      ], 64))
                ])
              ], 512)
            ])
          ])
        ])
      ])
    ], 2),
    (__props.content.requestForPriceFormId)
      ? (_openBlock(), _createBlock(_component_tress_modal, {
          key: 0,
          "is-open": isRequestForPriceOpen.value,
          onClose: closeRequestForPrice,
          onOpen: openRequestForPrice,
          class: "tress-modal-container--no-style"
        }, {
          header: _withCtx(() => [
            _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.$t(_unref(dictionary).product.requestPriceFor)) + " " + _toDisplayString(__props.content.name), 1)
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_40, [
              (_unref(umbracoForms).state[props.content?.requestForPriceFormId])
                ? (_openBlock(), _createBlock(_component_umbraco_form, {
                    key: 0,
                    definition: _unref(umbracoForms).state[props.content?.requestForPriceFormId],
                    "anti-forgery-token": __props.antiForgeryToken,
                    "pre-values": preValues.value
                  }, {
                    default: _withCtx(({ definition }) => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(definition.pages, (page) => {
                        return (_openBlock(), _createBlock(_component_umbraco_form_page, {
                          page: page,
                          key: page.caption
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(page.fieldsets, (fieldset) => {
                              return (_openBlock(), _createBlock(_component_umbraco_form_fieldset, {
                                fieldset: fieldset,
                                key: fieldset.id
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fieldset.columns, (column) => {
                                    return (_openBlock(), _createBlock(_component_umbraco_form_fieldset_column, {
                                      column: column,
                                      key: column.caption
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(column.fields, (field) => {
                                          return (_openBlock(), _createBlock(_component_umbraco_form_field, {
                                            field: field,
                                            key: field.caption
                                          }, null, 8, ["field"]))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1032, ["column"]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1032, ["fieldset"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["page"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["definition", "anti-forgery-token", "pre-values"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["is-open"]))
      : _createCommentVNode("", true),
    (__props.content.requestForFileFormId)
      ? (_openBlock(), _createBlock(_component_tress_modal, {
          key: 1,
          "is-open": isRequestForFileOpen.value,
          onClose: closeRequestForFile,
          onOpen: openRequestForFile,
          class: "tress-modal-container--no-style"
        }, {
          header: _withCtx(() => [
            _createElementVNode("p", _hoisted_41, _toDisplayString(_ctx.$t(_unref(dictionary).product.requestFileFor)) + " " + _toDisplayString(__props.content.name), 1)
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_42, [
              (_unref(umbracoForms).state[props.content?.requestForFileFormId])
                ? (_openBlock(), _createBlock(_component_umbraco_form, {
                    key: 0,
                    definition: _unref(umbracoForms).state[props.content?.requestForFileFormId],
                    "anti-forgery-token": __props.antiForgeryToken,
                    "pre-values": preValues.value
                  }, {
                    default: _withCtx(({ definition }) => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(definition.pages, (page) => {
                        return (_openBlock(), _createBlock(_component_umbraco_form_page, {
                          page: page,
                          key: page.caption
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(page.fieldsets, (fieldset) => {
                              return (_openBlock(), _createBlock(_component_umbraco_form_fieldset, {
                                fieldset: fieldset,
                                key: fieldset.id
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fieldset.columns, (column) => {
                                    return (_openBlock(), _createBlock(_component_umbraco_form_fieldset_column, {
                                      column: column,
                                      key: column.caption
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(column.fields, (field) => {
                                          return (_openBlock(), _createBlock(_component_umbraco_form_field, {
                                            field: field,
                                            key: field.caption
                                          }, null, 8, ["field"]))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1032, ["column"]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1032, ["fieldset"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1032, ["page"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["definition", "anti-forgery-token", "pre-values"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["is-open"]))
      : _createCommentVNode("", true),
    _createVNode(_component_tress_modal, {
      "is-open": isLoginFormOpen.value,
      "on@close": closeLoginForm,
      "on@open": openLoginForm,
      class: "tress-modal-container--no-padding"
    }, {
      header: _withCtx(() => [
        _hoisted_43
      ]),
      default: _withCtx(() => [
        _createVNode(TressLoginModal, { "login-url": loginUrlWithParameters.value }, null, 8, ["login-url"])
      ]),
      _: 1
    }, 8, ["is-open"])
  ], 64))
}
}

})